// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "kolibri.plugins.learn.app-" + ({"188":"H5PRunner","282":"xAPISchema"}[chunkId] || chunkId) + "-0.20.0a1.js";
};